import React from "react"
import parse from "html-react-parser"
import { LegalPrivacyTable } from "../components/legalPrivacyTable/LegalPrivacyTable"

const MARKER = "[[legal_privacy_table]]"

const normalizeMarkerParagraphs = html =>
  html.replace(/<p>\s*\[\[legal_privacy_table\]\]\s*<\/p>/g, MARKER)

const renderHtmlWithLegalPrivacyTable = html => {
  if (!html || typeof html !== "string") {
    return null
  }

  const normalizedHtml = normalizeMarkerParagraphs(html)

  if (!normalizedHtml.includes(MARKER)) {
    return parse(normalizedHtml)
  }

  return normalizedHtml.split(MARKER).map((part, index, parts) => (
    <React.Fragment key={index}>
      {part ? parse(part) : null}
      {index < parts.length - 1 && <LegalPrivacyTable />}
    </React.Fragment>
  ))
}

export { MARKER, renderHtmlWithLegalPrivacyTable }
